import { render } from "./VirtualMachineMigration.vue?vue&type=template&id=3c7fd00c"
import script from "./VirtualMachineMigration.vue?vue&type=script&lang=js"
export * from "./VirtualMachineMigration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__